<template>
    <article style="margin-top: 0;">
        <h2>Open sollicitatie</h2>
        <p>
            We zijn op zoek naar jou. Een technisch talent die haar of zijn kennis met onze jonge organisatie wil delen.
            Wil jij werken binnen een team waar je de ruimte krijgt om je talenten in te zetten op de manier die bij jou
            past? Wij doen dit graag samen met jou.
        </p>

        <p>
            Beschik je over HBO denk- en of werkniveau?, dan kun jij ons team versterken met jouw kennis en ervaring.
            Durf je de uitdaging aan? En ben je op zoek naar een afwisselende baan binnen een dynamisch en leuk team?
            Reageer op dit bericht en dan ben je van harte welkom om eens kennis te komen maken. Tot binnenkort!
        </p>

        <apply-job vacancy="open"></apply-job>
    </article>

</template>

<script>
    import ApplyJob from "@/components/ApplyJob.vue";

    export default {
        metaInfo: {
            title: "Open sollicitatie"
        },
        components: {
            ApplyJob
        }
    };
</script>